import { Flavor } from "../../../api/resources/Compute/Flavors";

export const findFlavorID = (flavors: Flavor[], machineType: string) => {
  return flavors.find((flavor) => flavor.name === machineType)?.id || "";
};
